import React from 'react';
import * as PropTypes from 'prop-types';
import { ButtonGroup, Nav } from 'react-bootstrap';
import ToolbarButton from '../Common/ToolbarButton';
import { STATUS_OFF, STATUS_ON } from '../../constants/common';
import {
  faFileCode,
  faFilePdf,
  faFileImage,
  faFileWord,
  faFile,
} from '@whitebox-learning/fontawesome-pro-light-svg-icons';

const iconType = (type) => {
  switch (type) {
    case 'html':
      return faFileCode;
    case 'pdf':
      return faFilePdf;
    case 'jpg':
    case 'png':
    case 'gif':
      return faFileImage;
    case 'doc':
      return faFileWord;
    default:
      return faFile;
  }
};

const Tool = ({ title, type, url, selected, selectItem }) => (
  <Nav.Item className="d-flex justify-content-between">
    {title}
    <ButtonGroup size="sm">
      <ToolbarButton
        enabled={true}
        status={selected === true ? STATUS_ON : STATUS_OFF}
        icon={iconType(type)}
        handleClick={() => selectItem(url)}
        ariaLabel={`View ${title}`}
      />
    </ButtonGroup>
  </Nav.Item>
);
Tool.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
  selected: PropTypes.bool,
  selectItem: PropTypes.func,
};
Tool.defaultProps = {
  type: 'html',
  selected: false,
};

export default Tool;
